module.exports = __webpack_public_path__ + "static/media/EBGaramond-Italic.f172f085.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/EBGaramond-Italic.ttf
// module id = 3102
// module chunks = 71